<template>
    <div class="accessIndex">
      <div class="accessIndex__head pt-5" v-if="booking_locations">
        <div class="accessIndex__head--item_left">
          <div class="type_buttom type_buttom__blue">
            CUPOS LIBRES
          </div>
          <div>
            <p>Disponilidad de ingresos</p>
            <p>del máximo permitido.</p>
          </div>
        </div>
        <div class="accessIndex__head--item_right">
          <div class="type_buttom type_buttom__green">
            CUPO LLENO
          </div>
          <div>
            <p>La locación está en su cupo máximo</p>
            <p>permitido con reservacion</p>
          </div>
        </div>
      </div>
      <div class="accessIndex__reload">
        <p class="accessIndex__text--title_access" v-if="booking_locations" >
          {{!hasAlreadyFilter?'Usuarios en la locación actualmente':'Usuarios en la locación '+dateFormat(filterSearchedDate)+' - '+dateFormat(filterSearchedDate2)}}
        </p>
        <v-hover>
          <div
            @click="findLocationsDatetime();date_available=false;"
            slot-scope="{ hover }"
            class="accessIndex__reload--container_access"
            :class="hover?'accessIndex__interaction--hover':''"  >
            <img src="../../../assets/img/reload_blue.svg">
          </div>
        </v-hover>
      </div>
      <p class="accessIndex__text--normal_access">Resumen</p>
      <div class="accessIndex__general_info">
        <div class="accessIndex__general_info--user_container">
          <div class="accessIndex__general_info--logo">
            <img src="../../../assets/img/grupo.svg">
          </div>
          <div class="accessIndex__general_info--user_total" v-if="booking_locations">
            <p class="accessIndex__text--big_title_access">{{total_current}}</p>
            <p class="accessIndex__text--small_access">Total usuarios</p>
          </div>
          <div class="accessIndex__general_info--user_total" v-else>
            <p class="accessIndex__text--big_title_access">Accesos</p>
            <p class="accessIndex__text--small_access">Locaciones con acceso de llave permanente</p>
          </div>
        </div>
      </div>

      <div class="accessIndex__locations">
        <div
          class="accessIndex__locations--item_access"
          v-for="location in new_locations" :key="location.id"
          @click="$router.push({name: location.location_type === 'Llave Permanente' ? 'permanent_key_access': 'location_access', params: {id: location.location_id, filter:hasAlreadyFilter,date: filterSearchedDate,date2:filterSearchedDate2,namex:location.name}})">
          <div class="accessIndex__locations--item_info">
            <div class="accessIndex__text--small_left">
              <p>{{location.name}}</p>
            </div>
            <div class="accessIndex__text--small_right" v-if="location.location_type !== 'Llave Permanente'">
              <div v-if="location.current_population < location.max_capacity"
              class="type_buttom type_buttom__blue">
                CUPOS LIBRES
              </div>
            </div>
          </div>
        </div>
        <div class="table_card__footer">
          <nav class="pagination" role="navegation" aria-label="pagination">
            <v-pagination
              :value ="page"
              :length="pages"
              @input ="changePage"
            />
          </nav>
        </div>
      </div>
    <!-- <section>
      <v-data-table
        :headers="headers"
        :items="current_user"
        hide-actions
        class="elevation-1">
        <template slot="items" slot-scope="props" @click="$router.push({name: 'location_access', params: {id: item.id}}">
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.quantity }}</td>
        </template>
      </v-data-table>
    </section> -->

    </div>
</template>

<script>
export default {
  data(){
    return{
      date_available:false,
      total_current: 0,
      current_user: [],
      locations: [],
      new_locations: [],
      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2:false,
      datePickerFirstClick:false,
      hasAlreadyFilter:false,
      filterSearchedDate:new Date().toISOString().substr(0, 10),
      filterSearchedDate2:new Date().toISOString().substr(0, 10),
      months:["ENE","FEB","MAR","ABR","MAY","JUN","JUL","AGO","SEP","OCT","NOV","DIC"],
      headers: [
        {text:'Locación', value: 'name'},
        {text:'Cantidad', value: 'quantity'}
      ],
      day_name_english: '',
      find_locations_datetime: [],
      location_get_population_quantity: [],
      myRequestInterval:null,
      page: 1,
      pages: 1,
      booking_locations: false
    }
  },
  computed: {
    current_today: function(){
      let d = new Date();
      let weekday = new Array(7);
      weekday[0] = "Sunday";
      weekday[1] = "Monday";
      weekday[2] = "Tuesday";
      weekday[3] = "Wednesday";
      weekday[4] = "Thursday";
      weekday[5] = "Friday";
      weekday[6] = "Saturday";
      let n = weekday[d.getDay()].toLowerCase();
      this.today = n;
      return n;
    }
  },
  methods:{
    findCurrentActivitySumatory(){
      try {
        this.$http.get('app/locations/current_activity_sumatory',{
          headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()},
          params:{
            current_day: this.day_name_english,
          }
        })
        .then(function(response){

          this.total_current = response.body.data

          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    modifyDateFormatToStatus(datex){
      var entries=datex.split('/');
      entries=[entries[2],entries[0],entries[1]];
      return entries.join("-");
    },
    dateFormat(datex){
      var sections=datex.split("-");
      var index=Number(sections[1])-1;
      sections[1]=this.months[index];
      datex=sections.join("/");
      return datex;
    },
    filterLocationsByButton(dates){
      var object = dates != undefined && dates != null ? dates : {date_from: '', date_to: '' }
      this.date = object.date_from;
      this.date2 = object.date_to;
      if(this.date!='Desde'&&this.date2!='Hasta'){
        this.datePickerFirstClick=true;
      }
      // alert(this.datePickerFirstClick+this.date+this.date2);
      if(this.datePickerFirstClick){
        this.hasAlreadyFilter=true;

        this.filterSearchedDate=this.modifyDateFormatToStatus(this.date);
        this.filterSearchedDate2=this.modifyDateFormatToStatus(this.date2);
        this.filterLocations(false);
      }
    },
    findLocationsDatetime(){
      var params = this.$route.params;
      /*       let date = new Date();
      let current_datetime = date.toLocaleString();  */
      try {
        const data={company:{id:this.getCompany().id}}
        this.$http.post('app/locations/locations_datetime',{data:this.encrypt(data).toString()},{
          headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()},
          params:{
            day_name: this.day_name_english,
            page: this.page,
            current_datetime: this.current_datetime()
          }
        })
        .then(function(response){
          this.find_locations_datetime = response.body.data
          this.location_get_population_quantity = response.body.meta.location_get_population_quantity
          this.pages = response.body.meta.pages

          this.new_locations = []

          for (var i = 0; i < this.find_locations_datetime.length; i++) {
            let new_obj ={
              name: this.location_get_population_quantity[i].location_name,
              current_population: this.location_get_population_quantity[i].current_population,
              max_capacity: 0,
              location_id: this.location_get_population_quantity[i].location_id,
              location_type: this.location_get_population_quantity[i].location_type
            }
            this.new_locations.push(new_obj)
          }

          let booking_locations = this.new_locations.find( ({ location_type }) => location_type === 'Reserva General');
          if(booking_locations){
            this.booking_locations = true;
          }

          console.log("<--------------New Locations");
          console.log(this.new_locations);

          // this.filterLocations(true);
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          this.findCurrentActivitySumatory();
          this.findCurrentActivity()
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    findCurrentActivity(){
      console.log("Find current activity");
      console.log(this.day_name_english);
      // var params = this.$route.params;
      /*       let date = new Date();
      let current_datetime = date.toLocaleString();  */
      try {
        this.$http.get('app/locations/general_activity',{
          headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()},
          params:{
            current_day: this.day_name_english,
            page: this.page,
          }
        })
        .then(function(response){

          var current_activity = response.body.data
          console.log(this.new_locations);
          for (var i = 0; i < current_activity.length; i++) {
            var temp = this.new_locations.find(element => element.location_id == current_activity[i][0])
            if (temp != undefined && typeof temp['max_capacity'] !== undefined && typeof temp['max_capacity'] !==  null){
              temp['max_capacity'] = current_activity[i][1]
            } else {
              console.log(temp);
            }
          }

          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    filterLocations(defaultOption){
      // var initialDate=new Date().toISOString().substr(0, 10);
      // var lastDate=new Date().toISOString().substr(0, 10);
      var initialDate= ""
      var lastDate=""
      if(!defaultOption){
        initialDate=this.filterSearchedDate;
        lastDate=this.filterSearchedDate2;
      }
      else{
        this.date= new Date().toISOString().substr(0, 10);
        this.date2= new Date().toISOString().substr(0, 10);
        this.datePickerFirstClick=false;
        this.hasAlreadyFilter=false;
      }

      try {
        this.$http.get('access/current_activity',{
        params:{
          offset_time: new Date().getTimezoneOffset(),
          first_date: initialDate,
          last_date: lastDate
        },
        headers:
          {
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()
          }
        }
      ).then(function(response){
          console.log(response);
          this.total_current=0;
          this.current_user= [];
          var vm = this;
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }

          /* this.getLocations().forEach(function(element){ */
          this.find_locations_datetime.forEach(function(element){
            if(response.body.data[element.id]!=undefined){
              var exit = response.body.data[element.id]["EXIT"]!=undefined ? response.body.data[element.id]["EXIT"] : 0;
              var entry = response.body.data[element.id]["ENTRY"]!=undefined ? response.body.data[element.id]["ENTRY"] : 0;
              var total = vm.hasAlreadyFilter ? entry : (entry-exit);

              total = total > 0 ? total : 0;
              if(element.attributes.location_type == "Centro Deportivo" || element.attributes.location_type == "Franquicia"){
                vm.current_user.push({id:element.id,name:element.attributes.name,quantity:total,max_spaces: element.attributes.location_schedule[vm.current_today].max_spaces});
                if(vm.mapCurrentPopulationLocation(element.id) > 0){
                  vm.total_current+=total;
                }

              }
            }else{
              if(element.attributes.location_type == "Centro Deportivo" || element.attributes.location_type == "Franquicia"){
                vm.current_user.push({id:element.id,name:element.attributes.name,quantity:0, max_spaces: element.attributes.location_schedule[vm.current_today].max_spaces })
              }
            }
          });
          /* console.table(response.body.data); */
          this.loaded = true;
          this.date_available=true;
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          // if (response.body.data.message != null &&
          //     response.body.data.message != undefined &&
          //     response.body.data.message != '' ){
          //     alert(response.body.data.message)
          // }else{
          //   alert(response.body.data)
          // }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    today: function() {
      let date =  new Date();
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
          dd = '0' + dd;
      }
        if (mm < 10) {
          mm = '0' + mm;
      }
      let date_complete = dd + '/' + mm + '/' + yyyy;
      this.currentTodayEnglish(date.getDay());
      return date_complete;
    },
    current_datetime: function(){
      let date = new Date().toISOString();
      /* let dateStr =
        date.getFullYear() + "-" +
        ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
        ("00" + date.getDate()).slice(-2) + " " +
        ("00" + date.getHours()).slice(-2) + ":" +
        ("00" + date.getMinutes()).slice(-2) + ":" +
        ("00" + date.getSeconds()).slice(-2);
        return dateStr */
        return date.replace(/[ZT]/g,' ')
    },
    currentTodayEnglish: function(day){
      let weekday = new Array(7);
      weekday[0] = "Sunday";
      weekday[1] = "Monday";
      weekday[2] = "Tuesday";
      weekday[3] = "Wednesday";
      weekday[4] = "Thursday";
      weekday[5] = "Friday";
      weekday[6] = "Saturday";
      let n = weekday[day];
      this.day_name_english = n;
      return n;
    },
    mapCurrentPopulationLocation: function(params_Location_id){
      let value = 0
      let locacion = this.location_get_population_quantity.find(e=>  e.location_id === Number(params_Location_id) )
      if (locacion !== undefined ){
        value = locacion.current_population
      }
      return value
    },
    mapNotCometOutLocation: function(params_Location_id){
      let value = 0
      let locacion = this.location_get_population_quantity.find(e=>  e.location_id === Number(params_Location_id) )
      if (locacion !== undefined ){
        value = locacion.not_comet_out
      }
      return value
    },
    changePage (page){
      console.log('====logPage=====')
      console.log(page)
      this.page = page
      this.findLocationsDatetime();
    }

  }, /* closed methods */
  mounted(){
    this.today();
    this.findLocationsDatetime();
    var vm = this;
    this.myRequestInterval=setInterval(function(){
    //     /* Actualiza cada 5 minutos */
        vm.findLocationsDatetime();
    },300*1000);
  },
  beforeDestroy(){
    clearInterval(this.myRequestInterval)
  }

}
</script>



// WEBPACK FOOTER //
// src/components/views/access/Index.vue